export default __webpack_public_path__ + "static/media/gitfusion-1.54e1103a.jpg";